import React from 'react'

function BuilderLink({
  url,
  children,
  target,
}: {
  url: string
  children?: React.ReactNode
  target?: string
}) {
  return (
    <a href={url} target={target}>
      {children ?? <p>Add a child element to this block</p>}
    </a>
  )
}

export default BuilderLink
